import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import { IAM_TENANT_SLUG } from "@/core/config";

const DEMO_TENANTS = new Set(["demo", "demo-hospitol"]);

/**
 * Bouton capture marketing visible uniquement en mode démo (dev + tenant démo).
 * Forcer : VITE_DEMO_CAPTURE=true | désactiver : VITE_DEMO_CAPTURE=false
 */
export function isDemoCaptureEnabled(): boolean {
  const flag = import.meta.env.VITE_DEMO_CAPTURE?.trim().toLowerCase();
  if (flag === "false" || flag === "0") return false;
  if (flag === "true" || flag === "1") return true;

  if (!import.meta.env.DEV) return false;

  const slug =
    loadStoredSession()?.tenant?.slug?.trim().toLowerCase() ?? IAM_TENANT_SLUG.trim().toLowerCase();

  return DEMO_TENANTS.has(slug);
}
